import { useDispatch, useSelector } from "react-redux";
import { fileActions } from "../../../../../store/files-slice";

export default function Pagination({ index, files }) {
    const selected = useSelector(state => state.file.selectedpagination);
    const dispatch = useDispatch();

    return <button type="button" className={`w-auto mt-3 btn ${selected === index ? "active" : ""}`} onClick={() => {
        dispatch(fileActions.setFilteredItems(files));
        dispatch(fileActions.setSelectedPagination(index));
    }}>{index + 1}</button>;
}
